export default "__VITE_ASSET__bb02674e__"